export const DATAMESH_ONLOAD_EVENT = "metas-user-verification-modal_onload";
export const DATAMESH_ONCLICK_SIGNIN_EVENT =
  "metas-user-verification-modal_onclick:signin";
export const DATAMESH_ONCLICK_GUEST_EVENT =
  "metas-user-verification-modal_onclick:guest";
export const TRACKING_CATEGORY = "login";
export const TRACKING_ACTION = "login-module-meta";
export const TRACKING_LABEL_ONLOAD = "login-module-meta-onload-fl_res";
export const TRACKING_LABEL_ONCLICK = "login-module-meta-click:sign_in-fl_res";
export const TRACKING_LABEL_ONCLICK_AS_GUEST =
  "login-module-meta-click:guest-fl_res";
